// extracted by mini-css-extract-plugin
module.exports = {"sharePopover":"az","shareText":"aA","show":"aB"};